import React, { Fragment, ReactElement } from 'react';
import { useHistory, withRouter } from 'react-router';
import useStyles from './styles';
import IdentificationDetailsForm from './components/identification_details_form';
import ContactDetailsForm from './components/contact_details_form';
import PaymentInfoForm from './components/payment_info_form';
import FirstSupplyForm from './components/first_supply_form';
import PreviousUseOfSpecialSchemesForm from './components/previous_use_special_schemes/components/form';
import FixedEstablishment from './components/fixed_establishments';
import FixedEstablishmentForm from './components/fixed_establishments/components/form';
import IdentificationOfOtherEuCountries from './components/identification_in_other_eu_countries';
import Declarations from './components/declarations_form';
import IdentificationOfOtherEuCountriesForm from './components/identification_in_other_eu_countries/components/form';
import ResponseForm from './components/approve_reject_form';
import ChangeIdentification from './components/change_identification';
import GridLayout from '../../components/molecules/grid_layout';
import {
  AuthRoles,
  RegistrationState,
  RegistrationStatus,
  SchemeTypes,
} from '../../config';
import { useDispatch } from 'react-redux';
import RegistrationDetailActions from '../../redux/reducers/registration_detail_reducer/actions';
import * as RegistrationDetailSelectors from '../../redux/reducers/registration_detail_reducer/selectors';
import { StateStatus } from '../../redux/utils/common';
import { Box, Button, IconButton, Typography } from '@material-ui/core';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TranslatedText from '../../components/atoms/translated_text';
import {
  allowedActions,
  initialDefaultValues,
  Translations,
} from './configuration';
import * as AuthSelectors from '../../redux/reducers/gl_auth_reducer/selectors';
import { handleIdentificationDetailsFormDefaultValues } from './components/identification_details_form/formDefaultValues';
import { handleContactDetailsFormDefaultValues } from './components/contact_details_form/formDefaultValues';
import { handlePaymentDetailsFormDefaultValues } from './components/payment_info_form/formDefaultValues';
import { handleFirstSupplyFormDefaultValues } from './components/first_supply_form/formDefaultValues';
import { handleChangeIdentificationDefaultValues } from './components/change_identification/formDefaultValues';
import { handleExclusionDetailsFormDefaultValues } from './components/exclusion_details/formDefaultValues';
import {
  Control,
  DeepMap,
  ErrorOption,
  FieldError,
  useForm,
} from 'react-hook-form';
import { FormFields } from './configuration';
import { getState } from '../../redux/store';
import { ReducerKeys } from '../../redux/reducers';
import BaseModal from '../../components/molecules/base_modal';
import { ModalIDs } from '../../redux/reducers/gl_modal_reducer/types';
import PreviousUseOfSpecialSchemes from './components/previous_use_special_schemes';
import NavigationConfig from '../../navigation/config';
import ModalActions from '../../redux/reducers/gl_modal_reducer/actions';
import AdministrationInfo from './components/administration';
import ExclusionDetailsForm from './components/exclusion_details';
import { showToastAction } from '../../components/atoms/toast_message';
import Dialog from '../../components/compounds/dialog';
import HeaderBar from 'components/molecules/header_bar';
import { handleDeclarationsFormDefaultValues } from './components/declarations_form/formDefaultValues';
import * as DateUtils from 'utils/dates';
import _ from 'lodash';

interface IProps {}
interface IElementsProps {
  size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  element: ReactElement;
  id: string;
  rowStyle?: any;
}

const RegistrationDetailPage: React.FC<IProps> = (props) => {
  // console.log('Render RegistrationDetailPage');
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { detail, id } = (props as any).match.params;
  const mode: 'VIEW' | 'EDIT' = detail.toUpperCase();

  const state = getState(ReducerKeys.REGISTRATION_LIST_REDUCER).registrationList
    .data;
  // console.log('---------->', state);
  let queryString = state ? `?goBack=true${state.queryString}` : '?goBack=true';

  const ROLE = AuthSelectors.useSelectUserRole();
  // const REGISTRATION_DETAIL_STATUS = RegistrationDetailSelectors.useGetRegistrationDetailStatus();
  // const COUNTRIES_NON_STATE_MEMBERS_STATUS = RegistrationDetailSelectors.useGetCountriesNonMemberStateStatus();
  // const SCHEME_TYPES_STATUS = RegistrationDetailSelectors.useGetSchemeTypesStatus();
  const REGISTRATION_DETAILS =
    RegistrationDetailSelectors.useGetRegistrationDetails();
  // const COUNTRIES_STATUS = RegistrationDetailSelectors.useGetCountriesStatus();
  const isExcluded: boolean =
    REGISTRATION_DETAILS && REGISTRATION_DETAILS.data
      ? REGISTRATION_DETAILS.data.identification_details.status ===
          RegistrationStatus.EXCL ||
        REGISTRATION_DETAILS.data.identification_details.state ===
          RegistrationState.EXCLUSION_REQUEST
      : false;
  const agentId =
    REGISTRATION_DETAILS && REGISTRATION_DETAILS.data
      ? REGISTRATION_DETAILS.data.identification_details.agent_id
      : null;
  React.useEffect(() => {
    dispatch(RegistrationDetailActions.fetchNonMemberStateCountriesAction());
    dispatch(RegistrationDetailActions.fetchImportCountriesAction());
    dispatch(RegistrationDetailActions.fetchAllCountriesAction());
    dispatch(RegistrationDetailActions.fetchMemberStateCountriesAction());
    dispatch(RegistrationDetailActions.fetchSchemeTypesAction());
    dispatch(RegistrationDetailActions.fetchCountriesExcludeCyprus());
    dispatch(
      RegistrationDetailActions.fetchRegistrationDetailAction({
        id: Number.parseInt(id),
      })
    );
  }, [dispatch]);

  const { errors, control, handleSubmit, reset, getValues, watch } =
    useForm<FormFields>({
      defaultValues: initialDefaultValues,
      mode: 'onBlur',
    });

  React.useEffect(() => {
    if (
      REGISTRATION_DETAILS &&
      REGISTRATION_DETAILS.data &&
      REGISTRATION_DETAILS.data.identification_details
    ) {
      reset({
        ...initialDefaultValues,
        ...handleExclusionDetailsFormDefaultValues(
          REGISTRATION_DETAILS.data.exclusionDetail
        ),
        ...handleIdentificationDetailsFormDefaultValues(
          REGISTRATION_DETAILS.data.identification_details
        ),
        ...handleContactDetailsFormDefaultValues(
          REGISTRATION_DETAILS.data.contact_details
        ),
        ...handlePaymentDetailsFormDefaultValues(
          REGISTRATION_DETAILS.data.payment_details[0]
        ),
        ...handleFirstSupplyFormDefaultValues(
          REGISTRATION_DETAILS.data.first_supply_details[0]
        ),
        ...handleChangeIdentificationDefaultValues(
          REGISTRATION_DETAILS.data.change_identification[0]
        ),
        ...handleDeclarationsFormDefaultValues(
          _.get(
            REGISTRATION_DETAILS.data.identification_details,
            'electronic_interface',
            false
          ),
          _.get(
            REGISTRATION_DETAILS.data.identification_details,
            'not_established',
            false
          ),
          _.get(
            REGISTRATION_DETAILS.data.identification_details,
            'country_of_business_id',
            null
          )
        ),
      });
    }
  }, [REGISTRATION_DETAILS]);

  React.useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      showToastAction(
        dispatch,
        'There are some errors in the form. Please review the form.',
        'warning'
      );
    }
  }, [errors]);

  const onSubmit = (data: any, event: any) => {
    if (event.nativeEvent.submitter.id === 'final') {
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_CONFIRM_FINAL_SUBMIT,
        params: { params: { data, event } },
      });
    } else {
      submitRegistration({ data, event });
    }
  };

  const submitRegistration = (modalResult: any) => {
    let data = modalResult.data;
    let event = modalResult.event;
    let payload = null;
    if (!isExcluded) {
      // NORMAL REGISTRATION FLOW
      payload = registrationFlow(data, event);
    } else {
      // EXCLUSION FLOW
      payload = exclusionFlow(data, event);
    }
    if (event.nativeEvent.submitter.id === 'final') {
      dispatch(
        RegistrationDetailActions.finalSubmitRegistration({
          payload: payload,
          id: id,
          history: history,
          isExcluded: isExcluded,
        })
      );
      dispatch(
        ModalActions.closeModalAction({
          modalID: ModalIDs.MODAL_CONFIRM_FINAL_SUBMIT,
        })
      );
    } else {
      dispatch(
        RegistrationDetailActions.temporarySaveRegistration({
          payload: payload,
          id: id,
          isExcluded: isExcluded,
        })
      );
    }
  };

  const exclusionFlow = (data: any, event: any) => {
    let payload: any = {};
    payload['exclusion_detail'] = {
      exclusion_type: Number.parseInt(data.exclusionDetails_reason),
      cessation_date: data.exclusionDetails_cessationDate,
      vat_num: data.exclusionDetails_vatNum,
      comments: data.exclusionDetails_comments,
      country_id: data.exclusionDetails_country,
    };
    return payload;
  };

  const registrationFlow = (data: any, event: any) => {
    let fixedEstablish = getState(
      ReducerKeys.REGISTRATION_DETAIL_REDUCER
    ).fixedEstablishments;
    let previousUseOfSpecialScheme = getState(
      ReducerKeys.REGISTRATION_DETAIL_REDUCER
    ).previousUseOfSpecialSchemes;
    let identificationInOtherEuCountries = getState(
      ReducerKeys.REGISTRATION_DETAIL_REDUCER
    ).identificationInOtherEuCountries;

    let payload: any = {};
    if (
      REGISTRATION_DETAILS.data.identification_details.scheme ===
      SchemeTypes.NON_EU
    ) {
      let non_union_scheme_detail = {
        place_of_business: data.identificationDetails_placeOfBusiness,
        issuing_country: data.identificationDetails_issuingCountry,
      };
      payload['non_union_scheme_detail'] = non_union_scheme_detail;
      payload['not_established'] = data.declarations_notEstablished;
    } else if (
      REGISTRATION_DETAILS.data.identification_details.scheme ===
      SchemeTypes.IOSS
    ) {
      let import_scheme_detail = {
        place_of_business: data.identificationDetails_placeOfBusiness,
        issuing_country: data.identificationDetails_issuingCountry,
      };
      payload['import_scheme_detail'] = import_scheme_detail;
    } else if (
      REGISTRATION_DETAILS.data.identification_details.scheme === SchemeTypes.EU
    ) {
      payload['electronic_interface'] = data.declarations_electronicInterface;
      payload['not_established'] = data.declarations_notEstablished;
      payload['country_of_business_id'] = data.declarations_notEstablished
        ? data.declarations_country_of_business_id
        : null;
      payload['vat_group'] = data.identificationDetails_vatGroup ? 'T' : 'F';
    }
    payload['applicant_trading_name'] = {
      trading_name: data.identificationDetails_trading_name,
    };
    payload['contact'] = {
      first_name: data.contactDetails_firstName,
      last_name: data.contactDetails_surname,
    };
    payload['applicant_address'] = {
      street: data.contactDetails_address,
      number: data.contactDetails_number,
      postal_code: data.contactDetails_postalcode,
      city: data.contactDetails_city,
      country: data.contactDetails_country,
    };
    payload['applicant_website'] = {
      websites: data.contactDetails_websites,
    };
    payload['applicant_detail'] = {
      telephone: (data.contactDetails_telephone as String).trim(),
      email: data.contactDetails_email,
      iban: data.paymentInfo_iban,
      oban: data.paymentInfo_oban,
      iban_oban_selection: data.paymentInfo_iban_oban_selection,
      account_holder: data.paymentInfo_accountHolder,
      bic: data.paymentInfo_bic,
    };
    payload['registration_detail'] = {
      date_of_first_supply: data.firstSupplyDetails_dateOfFirstSupply,
    };
    payload['fixed_establishments'] = fixedEstablish;
    payload['previous_use_of_special_scheme'] = previousUseOfSpecialScheme;
    payload['identification_in_other_eu_countries'] =
      identificationInOtherEuCountries;
    if (data.changeIdentification_country && data.changeIdentification_vatNum)
      payload['change_identification'] = {
        country_id: data.changeIdentification_country,
        vat_id_num: data.changeIdentification_vatNum,
      };

    return payload;
  };

  // PAGE SETUP START
  function handlePageElements(
    ossSheme: number,
    intermediary: boolean = false
  ): IElementsProps[] {
    switch (ossSheme) {
      case SchemeTypes.EU:
        return euSchemeElements();
      case SchemeTypes.NON_EU:
        return nonEuSchemeElements();
      default:
        if (intermediary) {
          return importSchemeIntermediaryElements();
        } else {
          return importSchemeElements();
        }
    }
  }

  function euSchemeElements(): IElementsProps[] {
    let administration: IElementsProps = {
      element: renderAdministrationInfo(
        classes,
        REGISTRATION_DETAILS.data.administration
      ),
      size: 12,
      id: 'administrationInfo',
    };

    let exclusionDetails: IElementsProps = {
      element: renderExclusionDetailsForm(
        classes,
        mode,
        REGISTRATION_DETAILS.data.identification_details.scheme,
        REGISTRATION_DETAILS.data.identification_details.is_agent,
        isExcluded,
        errors,
        control,
        watch('exclusionDetails_reason'),
        REGISTRATION_DETAILS.data.identification_details.agent_id ? true : false
      ),
      size: 12,
      id: 'exclusionDetails',
    };

    return [
      ...(isExcluded ? [exclusionDetails] : []),
      {
        element: renderIdentificationDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'identificationDetails',
      },
      {
        element: renderContactDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues
        ),
        size: 12,
        id: 'contactDetails',
      },
      {
        element: renderPaymentInfoForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues,
          watch
        ),
        size: 12,
        id: 'paymentInfo',
      },
      {
        element: renderFirstSupplyForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'firstSupply',
      },
      {
        element: renderFixedEstablishment(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          REGISTRATION_DETAILS.data.identification_details.vat_group
        ),
        size: 12,
        id: 'fixedEstablishment',
      },
      {
        element: renderIdentintificationOfOtherEuCountries(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded
        ),
        size: 12,
        id: 'identintificationOfOtherEuCountries',
      },
      {
        element: renderPreviousUseOfSpecialSchemes(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded
        ),
        size: 12,
        id: 'previousUseOfSpecialSchemes',
      },
      {
        element: renderChangeIdentification(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues
        ),
        size: 12,
        id: 'changeIdentification',
      },
      {
        element: renderDeclarations(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          watch
        ),
        size: 12,
        id: 'declarations',
      },
      ...(ROLE === AuthRoles.Admin ? [administration] : []),
      {
        element: renderBackToDashboard(history, queryString),
        size: 12,
        id: 'backToDashboard',
      },
    ];
  }

  function nonEuSchemeElements(): IElementsProps[] {
    let administration: IElementsProps = {
      element: renderAdministrationInfo(
        classes,
        REGISTRATION_DETAILS.data.administration
      ),
      size: 12,
      id: 'administrationInfo',
    };
    let exclusionDetails: IElementsProps = {
      element: renderExclusionDetailsForm(
        classes,
        mode,
        REGISTRATION_DETAILS.data.identification_details.scheme,
        REGISTRATION_DETAILS.data.identification_details.is_agent,
        isExcluded,
        errors,
        control,
        watch('exclusionDetails_reason'),
        REGISTRATION_DETAILS.data.identification_details.agent_id ? true : false
      ),
      size: 12,
      id: 'exclusionDetails',
    };
    return [
      ...(isExcluded ? [exclusionDetails] : []),
      {
        element: renderIdentificationDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'identificationDetails',
      },
      {
        element: renderContactDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues
        ),
        size: 12,
        id: 'contactDetails',
      },
      {
        element: renderPaymentInfoForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues,
          watch
        ),
        size: 12,
        id: 'paymentInfo',
      },
      {
        element: renderFirstSupplyForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'firstSupply',
      },
      {
        element: renderPreviousUseOfSpecialSchemes(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded
        ),
        size: 12,
        id: 'previousUseOfSpecialSchemes',
      },
      {
        element: renderDeclarations(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          watch
        ),
        size: 12,
        id: 'declarations',
      },
      ...(ROLE === AuthRoles.Admin ? [administration] : []),
      {
        element: renderBackToDashboard(history, queryString),
        size: 12,
        id: 'backToDashboard',
      },
    ];
  }

  function importSchemeIntermediaryElements(): IElementsProps[] {
    let administration: IElementsProps = {
      element: renderAdministrationInfo(
        classes,
        REGISTRATION_DETAILS.data.administration
      ),
      size: 12,
      id: 'administrationInfo',
    };
    let exclusionDetails: IElementsProps = {
      element: renderExclusionDetailsForm(
        classes,
        mode,
        REGISTRATION_DETAILS.data.identification_details.scheme,
        REGISTRATION_DETAILS.data.identification_details.is_agent,
        isExcluded,
        errors,
        control,
        watch('exclusionDetails_reason'),
        REGISTRATION_DETAILS.data.identification_details.agent_id ? true : false
      ),
      size: 12,
      id: 'exclusionDetails',
    };
    return [
      ...(isExcluded ? [exclusionDetails] : []),
      {
        element: renderIdentificationDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'identificationDetails',
      },
      {
        element: renderContactDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues
        ),
        size: 12,
        id: 'contactDetails',
      },
      {
        element: renderPaymentInfoForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues,
          watch
        ),
        size: 12,
        id: 'paymentInfo',
      },
      {
        element: renderFirstSupplyForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'firstSupply',
      },
      {
        element: renderFixedEstablishment(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          REGISTRATION_DETAILS.data.identification_details.vat_group
        ),
        size: 12,
        id: 'fixedEstablishment',
      },
      {
        element: renderIdentintificationOfOtherEuCountries(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded
        ),
        size: 12,
        id: 'identintificationOfOtherEuCountries',
      },
      {
        element: renderPreviousUseOfSpecialSchemes(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded
        ),
        size: 12,
        id: 'previousUseOfSpecialSchemes',
      },
      {
        element: renderChangeIdentification(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues
        ),
        size: 12,
        id: 'changeIdentification',
      },
      ...(ROLE === AuthRoles.Admin ? [administration] : []),
      {
        element: renderBackToDashboard(history, queryString),
        size: 12,
        id: 'backToDashboard',
      },
    ];
  }

  function importSchemeElements(): IElementsProps[] {
    let administration: IElementsProps = {
      element: renderAdministrationInfo(
        classes,
        REGISTRATION_DETAILS.data.administration
      ),
      size: 12,
      id: 'administrationInfo',
    };
    let exclusionDetails: IElementsProps = {
      element: renderExclusionDetailsForm(
        classes,
        mode,
        REGISTRATION_DETAILS.data.identification_details.scheme,
        REGISTRATION_DETAILS.data.identification_details.is_agent,
        isExcluded,
        errors,
        control,
        watch('exclusionDetails_reason'),
        REGISTRATION_DETAILS.data.identification_details.agent_id ? true : false
      ),
      size: 12,
      id: 'exclusionDetails',
    };
    return [
      ...(isExcluded ? [exclusionDetails] : []),
      {
        element: renderIdentificationDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'identificationDetails',
      },
      {
        element: renderContactDetailsForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control,
          getValues
        ),
        size: 12,
        id: 'contactDetails',
      },
      ...(!agentId
        ? [
            {
              element: renderPaymentInfoForm(
                classes,
                mode,
                REGISTRATION_DETAILS.data.identification_details.scheme,
                REGISTRATION_DETAILS.data.identification_details.is_agent,
                isExcluded,
                errors,
                control,
                getValues,
                watch
              ),
              size: 12,
              id: 'paymentInfo',
            } as any,
          ]
        : []),
      {
        element: renderFirstSupplyForm(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          errors,
          control
        ),
        size: 12,
        id: 'firstSupply',
      },
      {
        element: renderFixedEstablishment(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded,
          REGISTRATION_DETAILS.data.identification_details.vat_group
        ),
        size: 12,
        id: 'fixedEstablishment',
      },
      {
        element: renderPreviousUseOfSpecialSchemes(
          classes,
          mode,
          REGISTRATION_DETAILS.data.identification_details.scheme,
          REGISTRATION_DETAILS.data.identification_details.is_agent,
          isExcluded
        ),
        size: 12,
        id: 'previousUseOfSpecialSchemes',
      },
      ...(ROLE === AuthRoles.Admin ? [administration] : []),
      {
        element: renderBackToDashboard(history, queryString),
        size: 12,
        id: 'backToDashboard',
      },
    ];
  }
  // PAGE SETUP END

  const adminResponse = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_ADMIN_RESPONSE,
        params: {
          registration_id: id,
          isExcluded: isExcluded,
          applicant_id:
            REGISTRATION_DETAILS.data.identification_details.applicant_id,
          scheme: REGISTRATION_DETAILS.data.identification_details.scheme,
          exclusionReason: watch('exclusionDetails_reason'),
        },
      })
    );
  };

  return (
    <Fragment>
      <HeaderBar>
        <div className={classes.header}>
          <Box display="flex" alignItems={'center'}>
            <IconButton
              onClick={() =>
                history.push(
                  NavigationConfig.registrationListPage().path + queryString
                )
              }
              aria-label="delete"
              className={classes.back_button}
            >
              <ArrowBackIcon />
            </IconButton>
            <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
            <Typography component={'p'} variant={'h6'}>
              <TranslatedText
                textMap={Translations.page_title}
                defaultText={Translations.page_title.English}
              />
            </Typography>
          </Box>
          {REGISTRATION_DETAILS &&
            REGISTRATION_DETAILS.status === StateStatus.Success && (
              <Box display="flex" alignItems={'center'}>
                {mode === 'VIEW' &&
                  allowedActions.approve_reject.roles.includes(ROLE) && (
                    <Button
                      disabled={
                        !allowedActions.approve_reject.state_status.includes(
                          `${REGISTRATION_DETAILS.data.identification_details.status}${REGISTRATION_DETAILS.data.identification_details.state}`
                        )
                      }
                      className={classes.header_actions}
                      onClick={adminResponse}
                    >
                      <TranslatedText
                        textMap={Translations.action_approve_reject}
                      />
                    </Button>
                  )}
                {mode === 'EDIT' &&
                  allowedActions.temporary.roles.includes(ROLE) && (
                    <Button
                      id="temporary"
                      // type={'submit'}
                      // form={'registrationDetailsForm'}
                      disabled={
                        !allowedActions.temporary.state_status.includes(
                          `${REGISTRATION_DETAILS.data.identification_details.status}${REGISTRATION_DETAILS.data.identification_details.state}`
                        )
                      }
                      onClick={() => {
                        submitRegistration({
                          data: getValues(),
                          event: {
                            nativeEvent: {
                              submitter: { id: 'temporary' },
                            },
                          },
                        });
                      }}
                      className={classes.header_actions}
                    >
                      <TranslatedText
                        textMap={Translations.action_temporary_save}
                      />
                    </Button>
                  )}
                {mode === 'EDIT' && allowedActions.final.roles.includes(ROLE) && (
                  <Button
                    id="final"
                    type={'submit'}
                    form={'registrationDetailsForm'}
                    disabled={
                      !allowedActions.final.state_status.includes(
                        `${REGISTRATION_DETAILS.data.identification_details.status}${REGISTRATION_DETAILS.data.identification_details.state}`
                      )
                    }
                    // onClick={handleFormSubmition}
                    className={classes.header_actions}
                  >
                    <TranslatedText
                      textMap={Translations.action_final_submit}
                    />
                  </Button>
                )}
              </Box>
            )}
        </div>
      </HeaderBar>
      <div className={classes.subtitles}>
        <Typography component={'p'} variant={'h4'}>
          <TranslatedText
            textMap={Translations.subtitle1}
            defaultText={Translations.subtitle1.English}
          />
        </Typography>
        <Typography
          component={'p'}
          variant={'h6'}
          className={classes.subtitle2}
        >
          <TranslatedText
            textMap={Translations.subtitle2}
            defaultText={Translations.subtitle2.English}
          />
        </Typography>
      </div>
      {REGISTRATION_DETAILS &&
        REGISTRATION_DETAILS.status === StateStatus.Success && (
          // COUNTRIES_NON_STATE_MEMBERS_STATUS === StateStatus.Success &&
          // SCHEME_TYPES_STATUS === StateStatus.Success && (
          // COUNTRIES_STATUS === StateStatus.Success &&
          <form
            noValidate
            style={{ width: '100%' }}
            onSubmit={handleSubmit(onSubmit)}
            id="registrationDetailsForm"
          >
            <GridLayout
              elements={handlePageElements(
                REGISTRATION_DETAILS.data.identification_details.scheme,
                REGISTRATION_DETAILS.data.identification_details.is_agent
              )}
              spacing={3}
            />
          </form>
        )}
      <FormModals />
      <Dialog
        MODAL_ID={ModalIDs.MODAL_CONFIRM_FINAL_SUBMIT}
        title={Translations.dialog_confirm_title}
        body={Translations.dialog_confirm_body}
        actions={[
          {
            label: 'Yes',
            onClick: submitRegistration,
          },
          {
            label: 'No',
            onClick: () =>
              dispatch(
                ModalActions.closeModalAction({
                  modalID: ModalIDs.MODAL_CONFIRM_FINAL_SUBMIT,
                })
              ),
          },
        ]}
      />
    </Fragment>
  );
};

const FormModals = (): ReactElement => {
  return (
    <Fragment>
      <BaseModal
        modalID={ModalIDs.MODAL_IDENTIFICATION_IN_OTHER_EU_COUNTRIES}
        renderHeader={() => (
          <TranslatedText
            textMap={
              Translations.identificationInOtherEuCountries_add_header_button
            }
          />
        )}
        renderContent={(props) => (
          <IdentificationOfOtherEuCountriesForm {...props} />
        )}
      />
      <BaseModal
        modalID={ModalIDs.MODAL_PREVIOUS_USE_OF_SPECIAL_SCHEMES}
        renderHeader={() => (
          <TranslatedText
            textMap={Translations.previousUseOfSpecialScheme_add_header_button}
          />
        )}
        renderContent={(props) => (
          <PreviousUseOfSpecialSchemesForm {...props} />
        )}
      />
      <BaseModal
        modalID={ModalIDs.MODAL_FIXED_ESTABLISHMENT}
        renderHeader={() => (
          <TranslatedText
            textMap={Translations.fixedEstablishments_add_header_button}
          />
        )}
        renderContent={(props) => <FixedEstablishmentForm {...props} />}
      />
      <BaseModal
        modalID={ModalIDs.MODAL_ADMIN_RESPONSE}
        renderHeader={() => (
          <TranslatedText textMap={Translations.action_approve_reject} />
        )}
        renderContent={(props) => <ResponseForm {...props} />}
      />
    </Fragment>
  );
};

const renderExclusionDetailsForm = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  exclusion_reason: string | null,
  hasIntermediary: boolean
) => {
  return (
    <div className={classes.card}>
      <ExclusionDetailsForm
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
        exclusion_reason={exclusion_reason}
        hasIntermediary={hasIntermediary}
      />
    </div>
  );
};

const renderIdentificationDetailsForm = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <div className={classes.card}>
      <IdentificationDetailsForm
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
      />
    </div>
  );
};

const renderContactDetailsForm = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  getValues: any
) => {
  return (
    <div className={classes.card}>
      <ContactDetailsForm
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
        getValues={getValues}
      />
    </div>
  );
};

const renderPaymentInfoForm = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  getValues: any,
  watch: any
) => {
  return (
    <div className={classes.card}>
      <PaymentInfoForm
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
        getValues={getValues}
        watch={watch}
      />
    </div>
  );
};

const renderFirstSupplyForm = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <div className={classes.card}>
      <FirstSupplyForm
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
      />
    </div>
  );
};

const renderFixedEstablishment = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  vatGroup: string
) => {
  let vatGroupFlag: boolean = false;
  if (vatGroup == 'true' || vatGroup == 'T') vatGroupFlag = true;
  return (
    <div className={classes.card}>
      <FixedEstablishment
        mode={mode}
        isExcluded={isExcluded}
        vatGroup={vatGroupFlag}
      />
    </div>
  );
};

const renderIdentintificationOfOtherEuCountries = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean
) => {
  return (
    <div className={classes.card}>
      <IdentificationOfOtherEuCountries mode={mode} isExcluded={isExcluded} />
    </div>
  );
};

const renderPreviousUseOfSpecialSchemes = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean
) => {
  return (
    <div className={classes.card}>
      <PreviousUseOfSpecialSchemes mode={mode} isExcluded={isExcluded} />
    </div>
  );
};

const renderDeclarations = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  watch: (names?: string | string[]) => any
) => {
  return (
    <div className={classes.card}>
      <Declarations
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
        watch={watch}
      />
    </div>
  );
};

const renderChangeIdentification = (
  classes: any,
  mode: 'VIEW' | 'EDIT',
  scheme_type: SchemeTypes,
  is_agent: boolean,
  isExcluded: boolean,
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  getValues: any
) => {
  return (
    <div className={classes.card}>
      <ChangeIdentification
        mode={mode}
        scheme_type={scheme_type}
        is_agent={is_agent}
        isExcluded={isExcluded}
        errors={errors}
        control={control}
        getValues={getValues}
      />
    </div>
  );
};

const renderAdministrationInfo = (classes: any, administration: any) => {
  return (
    <div className={classes.card}>
      <AdministrationInfo data={administration} />
    </div>
  );
};

const renderBackToDashboard = (history: any, queryString: String) => {
  const goBackClick = () => {
    history.push(NavigationConfig.registrationListPage().path + queryString);
  };

  return (
    <div style={{ textAlign: 'left' }}>
      <Button onClick={goBackClick} variant={'contained'} color={'primary'}>
        <TranslatedText textMap={Translations.go_back} />
      </Button>
    </div>
  );
};

export default withRouter(RegistrationDetailPage);
